import React from 'react';
import { BrowserRouter } from 'react-router-dom';

import "./providers/i18nProvider";
import { createRoot } from "react-dom/client";
import { App } from './App';
import { ThemeProvider } from './contexts/ThemeContext';

const container = document.getElementById("root");
const root = createRoot(container!);

root.render(
  <React.StrictMode>
     
       <BrowserRouter>
         <ThemeProvider>
          <React.Suspense fallback="loading">
           <App />
           </React.Suspense>
         </ThemeProvider>
       </BrowserRouter>

  </React.StrictMode>
);